import { useSyncExternalStore } from "react";

export type Farbschema = "dunkel" | "hell" | "system";
export type WirksamesFarbschema = "dunkel" | "hell";

/** Muss mit dem Startskript in index.html übereinstimmen. */
const SPEICHER = "gui-creator:farbschema";
const SYSTEM_DUNKEL = "(prefers-color-scheme: dark)";
const KOPFFARBE: Record<WirksamesFarbschema, string> = { dunkel: "#262625", hell: "#ffffff" };

export function gelesen(roh: string | null): Farbschema {
  return roh === "hell" || roh === "system" ? roh : "dunkel";
}

export function aufloesen(wahl: Farbschema, systemDunkel: boolean): WirksamesFarbschema {
  if (wahl === "system") return systemDunkel ? "dunkel" : "hell";
  return wahl;
}

let wahl: Farbschema | undefined;
const hoerer = new Set<() => void>();

function gespeichert(): Farbschema {
  try {
    return gelesen(localStorage.getItem(SPEICHER));
  } catch {
    return "dunkel";
  }
}

const aktuelleWahl = (): Farbschema => (wahl ??= gespeichert());
const wirksam = (): WirksamesFarbschema => aufloesen(aktuelleWahl(), matchMedia(SYSTEM_DUNKEL).matches);

function anwenden(): void {
  const schema = wirksam();
  document.documentElement.dataset.farbschema = schema;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", KOPFFARBE[schema]);
  for (const h of hoerer) h();
}

export function farbschemaSetzen(neu: Farbschema): void {
  wahl = neu;
  try {
    localStorage.setItem(SPEICHER, neu);
  } catch {
    // Ohne Speicher gilt die Wahl bis zum Neuladen.
  }
  anwenden();
}

/** Folgt Geräteeinstellung und Wahl in anderen Tabs. */
export function farbschemaBeobachten(): void {
  matchMedia(SYSTEM_DUNKEL).addEventListener("change", () => {
    if (aktuelleWahl() === "system") anwenden();
  });
  window.addEventListener("storage", (e) => {
    if (e.key !== null && e.key !== SPEICHER) return;
    wahl = gelesen(e.newValue);
    anwenden();
  });
  anwenden();
}

function abonnieren(h: () => void): () => void {
  hoerer.add(h);
  return () => hoerer.delete(h);
}

export const useFarbschema = (): Farbschema => useSyncExternalStore(abonnieren, aktuelleWahl);
export const useWirksamesFarbschema = (): WirksamesFarbschema => useSyncExternalStore(abonnieren, wirksam);
